import { Button } from "@/components/ui/button";
import { Card, CardContent } from "@/components/ui/card";
import { ArrowRight } from "lucide-react";
import { ThemeToggle } from "@/components/ThemeToggle";
import { LanguageToggle } from "@/components/LanguageToggle";
import { motion } from "framer-motion";
import { useTranslation } from "react-i18next";
import { CookieConsentSettingsButton } from "@/components/cookie-consent/CookieConsentRoot";

const DOMIO_HUB_URL = "https://domio.com.pl";
const CLEANING_APP_URL = "https://cleaning.domio.com.pl";

const LandingPage = () => {
  const { t } = useTranslation();

  const handleLogin = () => {
    const returnTo = encodeURIComponent(
      CLEANING_APP_URL + window.location.pathname + window.location.search
    );
    window.location.href = `${DOMIO_HUB_URL}/login?returnTo=${returnTo}`;
  };

  return (
    <div className="min-h-screen bg-white dark:bg-[#1E222D] relative flex flex-col">
      {/* Theme Toggle and Language Toggle in top right corner */}
      <div className="absolute top-6 right-6 flex items-center gap-2 z-10">
        <LanguageToggle />
        <ThemeToggle />
      </div>

      {/* Main Content - Centered Login Card */}
      <div className="flex-1 flex items-center justify-center px-8 py-16">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5 }}
          className="w-full max-w-md"
        >
          <Card className="bg-white dark:bg-[#2C3241] border-0 shadow-lg dark:shadow-2xl rounded-2xl">
            <CardContent className="p-8">
              {/* Branding */}
              <div className="text-center mb-8">
                <h1 className="text-4xl font-bold mb-2">
                  <span className="text-gray-900 dark:text-white">{t("auth.brandName")}</span>
                  <span className="text-blue-600 dark:text-blue-400 ml-2">{t("auth.brandSubtitle")}</span>
                </h1>
                <p className="text-sm text-gray-500 dark:text-gray-400 mt-2">
                  {t("auth.brandDescription")}
                </p>
              </div>

              {/* Login Button */}
              <Button
                onClick={handleLogin}
                className="w-full bg-blue-600 hover:bg-blue-700 dark:bg-blue-500 dark:hover:bg-blue-600 text-white font-medium rounded-full h-12 text-base shadow-md"
              >
                {t("auth.login")}
                <ArrowRight className="ml-2 h-5 w-5" />
              </Button>

              {/* Navigation Dots */}
              <div className="flex justify-center gap-2 mt-6">
                <div className="w-2 h-2 rounded-full bg-blue-600 dark:bg-blue-400"></div>
                <div className="w-2 h-2 rounded-full bg-gray-300 dark:bg-gray-600"></div>
                <div className="w-2 h-2 rounded-full bg-gray-300 dark:bg-gray-600"></div>
                <div className="w-2 h-2 rounded-full bg-gray-300 dark:bg-gray-600"></div>
                <div className="w-2 h-2 rounded-full bg-gray-300 dark:bg-gray-600"></div>
              </div>
            </CardContent>
          </Card>
        </motion.div>
      </div>

      {/* Footer */}
      <footer className="py-4 text-center space-y-2">
        <p className="text-sm text-gray-500 dark:text-gray-400">
          {t("footer.copyright")}
        </p>
        <CookieConsentSettingsButton />
      </footer>
    </div>
  );
};

export default LandingPage;
